document.addEventListener("DOMContentLoaded", () => {
  const tabSections = document.querySelectorAll(".tab-section");

  tabSections.forEach(section => {
    const buttons = section.querySelectorAll(".tab-button");
    const panes = section.querySelectorAll(".tab-pane");
    const bonusSection = section.closest(".bonus-section");
    const ctaTexts = bonusSection
      ? bonusSection.querySelectorAll(".bonus-section__cta-text")
      : [];

    const setActive = (index) => {
      buttons.forEach((b) => b.classList.remove("active"));
      panes.forEach((p) => p.classList.remove("active"));
      ctaTexts.forEach((t) => t.classList.remove("active"));

      if (buttons[index]) buttons[index].classList.add("active");
      if (panes[index]) panes[index].classList.add("active");
      if (ctaTexts[index]) ctaTexts[index].classList.add("active");
    };

    buttons.forEach((btn, index) => {
      btn.addEventListener("click", () => setActive(index));
    });
  });
});